"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updataMatch = exports.projectTypeListAll = exports.projectTypeList = exports.projectTypeEdit = exports.projectTypeDel = exports.projectTypeAdd = exports.majorTypeUpdate = exports.majorType = exports.getMatchById = exports.categoriesList = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取项目类型列表(分页)
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var projectTypeList = exports.projectTypeList = function projectTypeList(data) {
  return _api.default.request({
    url: '/matchType/matchTypeList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取项目类型列表(不分页)
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var projectTypeListAll = exports.projectTypeListAll = function projectTypeListAll(data) {
  return _api.default.request({
    url: '/matchType/matchTypeListAll',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增项目类型
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var projectTypeAdd = exports.projectTypeAdd = function projectTypeAdd(data) {
  return _api.default.request({
    url: '/matchType/insertMatchType',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除项目类型
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var projectTypeDel = exports.projectTypeDel = function projectTypeDel(data) {
  return _api.default.request({
    url: '/matchType/deleteById',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑项目类型
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var projectTypeEdit = exports.projectTypeEdit = function projectTypeEdit(data) {
  return _api.default.request({
    url: '/matchType/updateMatchType',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取专业大类
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var majorType = exports.majorType = function majorType(data) {
  return _api.default.request({
    url: '/matchMajor/getMatchMajorListAll',
    method: 'post',
    data: data
  });
};

//获取专业大类  //更新
var majorTypeUpdate = exports.majorTypeUpdate = function majorTypeUpdate(data) {
  return _api.default.request({
    url: '/major/categories/list',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据项目ID回显
 * @author kkdy
 * @date 2022-03-17
 * @param {any} data
 * @returns {any}
 */
var getMatchById = exports.getMatchById = function getMatchById(data) {
  return _api.default.request({
    url: '/match/getMatchById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/** 
 * 描述 编辑项目
 * @author kkdy
 * @date 2022-03-17
 * @param {any} data
 * @returns {any}
 */
var updataMatch = exports.updataMatch = function updataMatch(data) {
  return _api.default.request({
    url: '/match/updateMatch',
    method: 'post',
    data: data
  });
};
var categoriesList = exports.categoriesList = function categoriesList(data) {
  return _api.default.request({
    url: '/major/categories/list',
    method: 'post',
    data: data
  });
};